
  import Events from '@/events/Events';
  import ScreenSize from '@/mixins/ScreenSize';

  export default {
    components: {
      RichText: () => import('@/components/elements/RichText'),
    },
    mixins: [ScreenSize],
    props: {
      content: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        isVideoLoaded: false,
        isFirstPlay: true,
        isLoaded: false,
        player: null,
      };
    },
    computed: {
      videoThumbnail() {
        if (
          this.content.yt_preview_type === 'thumbnail_image' &&
          this.content.yt_thumbnail_image
        ) {
          return this.content.yt_thumbnail_image.url;
        } else if (this.content.yt_preview_type === 'video_preview_image') {
          const videoId = this.extractYoutubeId(this.content.yt_video_url);
          return (
            `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` ||
            process.env.NUXT_ENV_FALLBACK_MEDIUM_HERO_IMAGE_STATIC
          );
        } else {
          return process.env.NUXT_ENV_FALLBACK_MEDIUM_HERO_IMAGE_STATIC;
        }
      },
      videoAltText() {
        return (
          this.content.yt_thumbnail_image?.alternativeText ||
          this.$t('videos.alternative_text_default')
        );
      },
    },
    mounted() {
      this.sizeOfVideoColumn = this.content.video_width
        ? Number(this.content.video_width.split('_')[1])
        : 6;

      if (
        this.content.yt_preview_type &&
        this.content.yt_preview_type === 'direct_video'
      ) {
        this.isVideoLoaded = true;
        this.loadYouTubeAPI().then(() => {
          this.initializeYouTubePlayer(false);
        });
      }

      this.isLoaded = true;
    },
    methods: {
      loadVideo() {
        if (!this.isVideoLoaded) {
          this.isVideoLoaded = true;
          this.loadYouTubeAPI().then(() => {
            this.initializeYouTubePlayer(true);
          });
        } else if (this.player) {
          this.player.playVideo();
        }
      },
      loadYouTubeAPI() {
        return new Promise((resolve) => {
          if (window.YT && window.YT.Player) {
            resolve();
          } else {
            const script = document.createElement('script');
            script.src = 'https://www.youtube.com/iframe_api';
            script.async = true;
            script.onload = () => {
              window.onYouTubeIframeAPIReady = () => {
                resolve();
              };
            };
            document.head.appendChild(script);
          }
        });
      },
      initializeYouTubePlayer(autoplay = false) {
        this.player = new window.YT.Player(this.$refs.youtubePlayerContainer, {
          videoId: this.extractYoutubeId(this.content.yt_video_url),
          height: '100%',
          width: '100%',
          events: {
            onReady: (event) => {
              if (autoplay) {
                event.target.playVideo();
              }
            },
            onStateChange: this.onPlayerStateChange,
          },
          playerVars: {
            autoplay: autoplay ? 1 : 0,
            rel: 0,
          },
        });
      },
      onPlayerStateChange(event) {
        if (event.data === window.YT.PlayerState.PLAYING && this.isFirstPlay) {
          this.$emitWithClientData(Events.VideoStarted, {
            url: this.content.yt_video_url,
          });
          this.isFirstPlay = false;
        }
      },
      extractYoutubeId(url) {
        const regExp = /^.*(youtu\.be\/|v\/|embed\/|watch\?v=|v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return match && match[2].length === 11 ? match[2] : null;
      },
    },
  };
